<template>
  <v-container style="max-width: 940px;">
    <h1 class="post--title">{{title}}</h1>
    <br/>    
    <ShareNetwork
      class="network"
      v-for="network in networks"
      :key="network.network"
      :network="network.network"
      :style="{backgroundColor: network.color}"
      :url="sharing.url"
      :title="sharing.title"
      :description="sharing.description"
      :media="sharing.media"
      hashtags="HortusBox"
    >
      <i class="networkIcon" :class="network.icon"></i>
      <span class="networkName">{{ network.name }}</span>
    </ShareNetwork>
    <div class="content">
      <v-parallax v-if="!!imageHeader" :src="imageHeader"></v-parallax>
      <p v-html="content" class="my-5"></p>
      <v-parallax v-if="!!imageFooter" :src="imageFooter"></v-parallax>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import MarkdownIt from 'markdown-it'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

export default {
  metaInfo () {
    return {
      title : 'HortusBox - ' + this.post.title,
      meta: [
        { property: 'og:type', content: 'article' },
        { property: 'og:title', content: this.post.title },
        { property: 'og:description', content: this.post.brief },
        { property: 'og:image', content: this.post.imageHeader ? 'https://gimc.service.hortusbox.com/gimc/strapi' + this.post.imageHeader.url : '' },
        { property: 'og:url', content: this.$route.params.slug ? 'https://hortusbox.com/blog/post/' + this.$route.params.slug : '' },
      ]
    }
  },
  data: () => ({
    post: {},
    sharing: {
      url: '',
      title: '',
      description: '',
      media: '',
    },
    networks: [
      { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f', color: '#1877f2' },
      { network: 'linkedin', name: 'LinkedIn', icon: 'fab fa-linkedin', color: '#007bb5' },
      { network: 'twitter', name: 'Twitter', icon: 'fab fa-twitter', color: '#1da1f2' },
      { network: 'pinterest', name: 'Pinterest', icon: 'fab fa-pinterest', color: '#bd081c' },
    ]
  }),
  computed: {
    title () {
      return this.post?.title ?? ''
    },
    imageHeader () {
      return this.post?.imageHeader?.url ? `/gimc/strapi${this.post.imageHeader.url}?height=600` : ''
    },
    imageFooter () {
      return this.post?.imageFooter?.url ? `/gimc/strapi${this.post.imageFooter.url}?height=600` : ''
    },
    content () {
      return this.post?.body ?? ''
    }
  },
  mounted () {
    this.$vuetify.goTo(0)
    axios.get('/strapi/posts?slug='+this.$route.params.slug)
    .then( (res) => {
      this.post = res.data[0]

      const md = new MarkdownIt()
      this.post.body = md.render(this.post.body)
      const regex = /<img src="(.*)" alt="(.*)" ?\/?>/gm;
      let m;

      while ((m = regex.exec(this.post.body)) !== null) {
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }
        
        if (m.length === 3) {
          let url = m[1].replace('/uploads/', `/gimc/strapi/uploads/`)
          this.post.body = this.post.body.replace(m[0], 
          `<div class="post-body-img--container">
            <img class="post-body-img" src="${url}?height=320" alt="${m[2]}" />
          </div>`)
        }
      }
    })
    .catch( (err) => {
      console.log(err)
    }),
    this.sharing.url = `https://hortusbox.com/blog/post/${this.$route.params.slug}`,
    this.sharing.title = this.post.title ? this.post.title : '',
    this.sharing.description = this.post.brief,
    this.sharing.media = this.post.imageHeader ? 'https://gimc.service.hortusbox.com/gimc/strapi' + this.post.imageHeader.url : ''
  }
}
</script>

<style>
.content {
  margin-top: 1rem;
}
.network {
  max-width: 50px;
  text-decoration: none;
  margin-right: .5rem;
}
.networkIcon {
  color: white;
  margin-right: .5rem;
  margin-left: .5rem;
}
.networkName {
  transition: margin .7s;
  padding: .5rem;
  color: white;
}
.networkName:hover {
  margin: .8rem;
}
.post--title {
  color: #0b755f;
}
.post-body-img--container {
  text-align: center;
}
.post-body-img {
  height: 300px;
}
@media screen and (max-width: 800px) {
  .post-body-img {
    height: 200px;
  }
  .network {
    padding: 0.5rem;
  }
  .networkName {
    display: none;
  }
} 
</style>